const colorsForChart = ['#0069d9', '#f67019', '#f53794', '#537bc4', '#acc236', '#166a8f', '#00a950', '#8549ba', '#58595b'];

export { colorsForChart };
